/* eslint max-len: 0 */
import React, { SVGProps } from 'react';

export const BubbleWarning = ( props: SVGProps<SVGSVGElement> ) => (
	<svg
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{ ...props }
	>
		<path d='M12 6.75C12.4142 6.75 12.75 7.08579 12.75 7.5V12C12.75 12.4142 12.4142 12.75 12 12.75C11.5858 12.75 11.25 12.4142 11.25 12V7.5C11.25 7.08579 11.5858 6.75 12 6.75Z' />
		<path d='M12 13.25C12.4142 13.25 12.75 13.5858 12.75 14C12.75 14.4142 12.4142 14.75 12 14.75C11.5858 14.75 11.25 14.4142 11.25 14C11.25 13.5858 11.5858 13.25 12 13.25Z' />
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M5.5 3.25C4.25736 3.25 3.25 4.25736 3.25 5.5V14.5417C3.25 15.7843 4.25736 16.7917 5.5 16.7917H7.81987C7.88852 16.7917 7.95414 16.8199 8.00136 16.8697L11.4555 20.5158C11.5972 20.6653 11.7941 20.75 12 20.75C12.2059 20.75 12.4028 20.6653 12.5445 20.5158L15.9986 16.8697C16.0459 16.8199 16.1115 16.7917 16.1801 16.7917H18.5C19.7426 16.7917 20.75 15.7843 20.75 14.5417V5.5C20.75 4.25736 19.7426 3.25 18.5 3.25H5.5ZM4.75 5.5C4.75 5.08579 5.08579 4.75 5.5 4.75H18.5C18.9142 4.75 19.25 5.08579 19.25 5.5V14.5417C19.25 14.9559 18.9142 15.2917 18.5 15.2917H16.1801C15.6996 15.2917 15.2402 15.4893 14.9097 15.8381L12 18.9095L9.09029 15.8381C8.7598 15.4893 8.3004 15.2917 7.81987 15.2917H5.5C5.08579 15.2917 4.75 14.9559 4.75 14.5417V5.5Z'
		/>
	</svg>
);
